import styled from '@emotion/styled';

import { HeadingText20, BodyTextSmall, pxToRem } from '@modernhealth/vital-components';

import Switch from 'react-switch';
import { color } from 'src/shared/styles/variables';
import chevronRightIcon from 'src/modules/scheduledContent/assets/chevron-right-icon.svg';
import { colors } from '@modernhealth/vital-foundation';
import { useTranslation } from 'react-i18next';

interface OptionRowProps {
    title: string;
    description: string;
    onAction: () => void;
    switchValue?: boolean;
    disabled?: boolean;
}

export const OptionRow: React.FC<OptionRowProps> = ({
    title,
    description,
    onAction,
    switchValue,
    disabled,
}) => {
    const { t } = useTranslation();

    const OptionBody = () => (
        <OptionContent>
            <HeadingText20 marginBottom={12}>{t(title)}</HeadingText20>
            <BodyTextSmall>{t(description)}</BodyTextSmall>
        </OptionContent>
    );

    if (switchValue !== undefined) {
        return (
            <BaseOptionRow>
                <OptionBody />
                <Switch
                    checked={switchValue}
                    onChange={onAction}
                    onColor={color.royalBlue}
                    offColor={color.casper}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    width={38}
                    height={24}
                    borderRadius={12}
                    handleDiameter={19}
                    disabled={disabled}
                    alt="option-switch"
                />
            </BaseOptionRow>
        );
    }

    return (
        <LinkOptionRow onClick={onAction}>
            <OptionBody />
            <ArrowImage src={chevronRightIcon} alt="arrow forward" />
        </LinkOptionRow>
    );
};

const BaseOptionRow = styled.div({
    display: 'flex',
    justifyContent: 'space-between',

    '&:not(:last-child)': {
        borderBottom: `2px solid ${colors.gray05}`,
        paddingBottom: pxToRem(24),
        marginBottom: pxToRem(19),
    },
});

const LinkOptionRow = styled(BaseOptionRow)({
    cursor: 'pointer',
});

const OptionContent = styled.div({
    display: 'block',
});

const ArrowImage = styled.img({
    marginRight: pxToRem(12),
});
